import React, { useContext } from 'react';
import moment from 'moment/moment';
import { UserContext } from 'venn-components';
import { AlertNote, StudioButton } from 'venn-ui-kit';
import { cn } from '@/lib/utils';
import { useTheme } from 'styled-components';
import { useHasFF, useModal } from 'venn-utils';
import { PanelItem } from '../components/shared';
import { BlockAssignmentTutorialModal } from '../../../../BlockAssignmentTutorialModal';

const getIsNewUser = (created: number | undefined) => {
  return moment.utc(created).isSameOrAfter(moment.utc('2025-10-29'));
};

export const InputTutorialMessage = () => {
  const { profileSettings } = useContext(UserContext);
  const isNewUser = getIsNewUser(profileSettings?.user.created);
  const { Colors, Videos } = useTheme();
  const hasBlockAssignment = useHasFF('block_assignment_ff');
  const [isVideoOpen, openVideo, closeVideo] = useModal();

  if (isNewUser || !hasBlockAssignment) {
    return null;
  }

  return (
    <>
      <PanelItem>
        <AlertNote size="small">
          <div className={cn('flex gap-[8px]')}>
            Set subjects, date ranges, and benchmarks in the Inputs panel.
            {Videos.blockMultiselectOnboarding && (
              <StudioButton size="medium" onClick={openVideo} color={Colors.HighlightDark}>
                Watch how
              </StudioButton>
            )}
          </div>
        </AlertNote>
      </PanelItem>
      {isVideoOpen && <BlockAssignmentTutorialModal onClose={closeVideo} />}
    </>
  );
};
